import React from "react";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../../../Context/AddProWakel";
const FillDetailParadan = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RPD_from, RPD_to, RPD_getPrint, RPD_filterPara } = value;
          return (
            <>
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div className="col-lg-3  col-4 form-inline">
                  <div className="row form-inline">
                    <div className="col-6 form-inline">
                      <p
                        className="font-weight-bold bg-white  f3"
                        style={{ color: "#000" }}
                      ></p>
                      <span style={{ color: "#2C3539" }}>:</span>
                      <p
                        className="font-weight-bold bg-white  f4"
                        style={{ color: "#000" }}
                      >
                        {RPD_to}
                      </p>
                    </div>
                    <div className='col-lg-6 col-6 form-inline"'>
                      <label className=" font-weight-bold f3 text-warning">
                        :بۆ بەرواری{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-4 form-inline">
                  <div className="row form-inline">
                    <div className="col-6 form-inline">
                      <p
                        className="font-weight-bold bg-white  f3"
                        style={{ color: "#000" }}
                      ></p>
                      <span style={{ color: "#2C3539" }}>:</span>
                      <p
                        className="font-weight-bold bg-white  f4"
                        style={{ color: "#000" }}
                      >
                        {RPD_from}
                      </p>
                    </div>
                    <div className='col-lg-6 col-6 form-inline"'>
                      <label className=" font-weight-bold f3 text-warning">
                        :لە بەرواری{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-4 mt3">
                  <div className="row">
                    <div className="col-lg-2 ">
                      <button
                        onClick={RPD_getPrint}
                        className="btn btn-warning "
                      >
                        <Link to="/print-paradan-raport" className="text-dark">
                          Print
                        </Link>
                      </button>
                    </div>
                    <div className="col-lg-8 col-12">
                      <h3 className="font-weight-bold text-warning">
                        ڕاپۆرتی پارەدان
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-4 mt3 form-group d-flex">
                  <div className="row d-flex">
                    <div className="col-lg-3 ">
                      <button
                        onClick={() => RPD_filterPara("$")}
                        className="btn btn-success"
                      >
                        $
                      </button>
                    </div>
                    <div className="col-lg-3 ">
                      <button
                        onClick={() => RPD_filterPara("ID")}
                        className="btn btn-danger"
                      >
                        ID
                      </button>
                    </div>
                    <div className="col-lg-3 ">
                      <button
                        onClick={() => RPD_filterPara("R")}
                        className="btn btn-warning"
                      >
                        R
                      </button>
                    </div>
                    <div className="col-lg-3 ">
                      <button
                        onClick={() => RPD_filterPara("A")}
                        className="btn btn-info"
                      >
                        A
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FillDetailParadan;
